import { Button, Col, Divider, Modal, Row, Table, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteChildrenProps } from "react-router";
import { ReportTypeEnum } from "../../../../constants/constants";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import { ConfigFileModel, ConfigFileTypeModel } from "../../../../models/onboarding/onboarding";
import { ClientService } from "../../../../services/client.service";
import { DATA_TABLE_UTIL } from "../../../../utils/data-table.utils";
import UTIL from "../../../../utils/utils";
import { CheckedIcon, InfoIcon } from "../../../atoms/icon";
import "./onboarding.scss";

interface Props extends RouteChildrenProps { }

export default function ECAPLeaderOnboarding(props: Props) {

    const { t } = useTranslation();
    const [steps, setSteps] = useState<ConfigFileTypeModel[]>([]);
    const [currentStep, setCurrentStep] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fileData, setFileDate] = useState<any[]>();
    const [columns, setColumns] = useState<any[]>();

    const goback = () => {
        props.history.push(ROUTE_PATHS.ECAPLeader);
    }


    const back = () => {
        setCurrentStep(p => p - 1)
    }

    const next = () => {
        setCurrentStep(p => p + 1)
    }

    const done = () => {
        props.history.push(ROUTE_PATHS.ECAPLeader);
    }

    const handleUpload = (file: File, fileType: string) => {
        uploadFile(file, fileType);
        return "";
    }

    const confirmDelete = (fileType: string) => {
        Modal.confirm({
            content: 'Do you want to delete this file?',
            onOk: () => deleteFile(fileType),
            icon: '',
            width: 304
        });
    }

    const deleteFile = (fileType: string) => {
        ClientService.deleteConfigFile(fileType).then(res => {
            const st = steps;
            const f = st[currentStep].files.find(p => p.type === fileType);
            if (f) {
                clearFile(f);
                setSteps([...st]);
            }
        })
    }

    const clearFile = (f: ConfigFileModel) => {
        f.data = [];
        f.columns = [];
        f.file_name = "";
        f.fileError = "";
    }

    const uploadFile = async (file: File, fileType: string) => {
        const st = steps;
        const f = st[currentStep].files.find(p => p.type === fileType);
        if (f) {
            clearFile(f);
            ClientService.uploadConfigFile(fileType, file).then(res => {
                f.data = res.data.file_json_data;
                f.columns = DATA_TABLE_UTIL.getColumnsTableData(f.data, undefined, res.data.file_md?.columns);
                f.file_name = res.data.file_name;
            }).catch(error => {
                f.fileError = error?.response?.data?.message;
            }).finally(() => {
                setSteps([...st]);
            });
        }
    }

    const viewFileData = (fileType: string) => {
        const file = steps[currentStep].files.find(p => p.type === fileType);
        if (!file) {
            return;
        }
        if (file.data && file.data.length) {
            setColumns(file.columns);
            setFileDate(file.data);
            setIsModalVisible(true);
        } else {
            ClientService.getConfigFileDetail(fileType).then(res => {
                file.data = res.data.file_json_data;
                file.columns = DATA_TABLE_UTIL.getColumnsTableData(file.data, undefined, res.data.file_md?.columns);
                file.file_name = res.data.file_name;
                setColumns(file.columns);
                setFileDate(file.data);
                setIsModalVisible(true);
            })
        }
    }

    const dowloadSampleFile = (fileType: string) => {
        ClientService.downloadSampleConfigFile(fileType).then(res => {
            let csvContent = "data:text/csv;charset=utf-8,"
                + res.data;
            var encodedUri = encodeURI(csvContent);
            downloadURI(encodedUri, `${fileType}.csv`)
        });
    }

    const downloadURI = (uri?: string, name: string = "") => {
        if (!uri) {
            return;
        }
        var link = document.createElement("a");
        link.setAttribute('download', name);
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    const dummyRequest = (options: any) => {
        setTimeout(() => {
            options.onSuccess("ok");
        }, 0);
    };

    useEffect(() => {

        const configs = ClientService.getResourcesAsync();
        const fileList = ClientService.getConfigFiles();

        Promise.all([configs, fileList]).then(res => {
            const ecapleaderConfig = res[0].data.ecap_leader?.config_file_types;
            const files: any[] = res[1].data;

            if (ecapleaderConfig) {
                let st: ConfigFileTypeModel[] = Object.keys(ecapleaderConfig).map(k => {

                    const f: ConfigFileModel[] = (ecapleaderConfig[k].files as any[]).map(p => {
                        return {
                            name: p.name,
                            type: p.type,
                            file_name: files.find(q => p.type === q.file_type)?.file_name
                        }
                    });

                    return {
                        risk_type: k,
                        files: f,
                        title: k === ReportTypeEnum.common ? t("ECAPLeader.lbECAPLeaderOnboarding") : UTIL.getECapReportTypeDisplay(k),
                        desName: k === ReportTypeEnum.common ? "across ECAP Leader" : `in ${UTIL.getECapReportTypeDisplay(k)}`,
                    }
                })

                st = st.filter(s => s.risk_type !== ReportTypeEnum.Ramp);
                setSteps(st);
            }

        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="ecap-leader-onboarding-wrapper">

            <Row gutter={20}>
                <Col xs={0} sm={5}>

                </Col>
                <Col xs={0} sm={14}>
                    {
                        (steps && !!steps.length) &&
                        <div className="main-form">
                            {
                                steps.map((item, index) =>
                                    <React.Fragment key={index}>
                                        {
                                            currentStep === index &&
                                            <div>

                                                <div className="form-header">

                                                    <div className="title">
                                                        {item.title}
                                                    </div>
                                                    <p className="text-center">
                                                        {t("ECAPLeader.onBoardingDes")}
                                                    </p>
                                                </div>

                                                <div className="check-list">
                                                    <p>
                                                        {t("ECAPLeader.lbCSVChecklist")}
                                                    </p>
                                                    <Divider />
                                                    <span>
                                                        {t("ECAPLeader.uploadCSVDes", { parram: item.desName })}
                                                    </span>
                                                </div>

                                                <div className="file-wrapper">
                                                    {
                                                        item.files && item.files.map((f, j) =>
                                                            <div className="file-item" key={j}>
                                                                <div className="content-item">
                                                                    <label>
                                                                        <span>*</span>
                                                                        {f.name}
                                                                    </label>
                                                                    <span className="custom-link" onClick={() => dowloadSampleFile(f.type)}>
                                                                        {t("ECAPLeader.lbCheckSample")}
                                                                    </span>

                                                                    {
                                                                        f.file_name &&
                                                                        <span className="file-name">
                                                                            <span><CheckedIcon /></span> <span>{f.file_name}</span>
                                                                        </span>
                                                                    }

                                                                    {
                                                                        f.fileError &&
                                                                        <span className="text-error">
                                                                            <span><InfoIcon /></span> <span>{f.fileError}</span>
                                                                        </span>
                                                                    }
                                                                </div>
                                                                <div className="file-action">

                                                                    {
                                                                        !f.file_name ? <Upload
                                                                            multiple={false}
                                                                            action={(file) => handleUpload(file, f.type)}
                                                                            maxCount={1}
                                                                            listType="picture"
                                                                            accept=".csv"
                                                                            className="upload-file"
                                                                            showUploadList={false}
                                                                            customRequest={dummyRequest}>
                                                                            {
                                                                                <Button className="btn-upload" shape="round">{(t("ECAPLeader.btnUploadFile"))}</Button>
                                                                            }
                                                                        </Upload> :
                                                                            <React.Fragment>
                                                                                <Button className="btn-view" shape="round" onClick={() => viewFileData(f.type)}>{(t("ECAPLeader.btnView"))}</Button>
                                                                                <Button className="btn-delete" shape="round" onClick={() => confirmDelete(f.type)} >{(t("ECAPLeader.btnDelete"))}</Button>
                                                                            </React.Fragment>
                                                                    }
                                                                </div>
                                                            </div>)
                                                    }

                                                </div>
                                            </div>
                                        }

                                    </React.Fragment>
                                )
                            }

                            <div className="slide-dot-wrapper">
                                {
                                    steps && steps.map((item, index) =>
                                        <div key={index} className={`slide-dot ${currentStep === index ? "active" : ""}`} ></div>)
                                }
                            </div>

                            <Row gutter={12} className="form-action">
                                <Col span={12}>
                                    {
                                        currentStep >= 0 &&
                                        <Button type="default" onClick={currentStep > 0 ? back : goback} block shape="round">
                                            {t("Onboarding.btnGoback")}
                                        </Button>
                                    }

                                </Col>
                                <Col span={12}>
                                    {

                                        currentStep === steps.length - 1 ?
                                            <Button type="primary" onClick={done} block shape="round">
                                                {t("ECAPLeader.btnDone")}
                                            </Button> : <Button type="primary" onClick={next} block shape="round">
                                                {t("ECAPLeader.btnNext")}
                                            </Button>
                                    }

                                </Col>
                            </Row>
                        </div>
                    }

                </Col>
                <Col xs={0} sm={5}>
                </Col>
            </Row>

            <Modal className="table-file-data" width={400} centered={true} footer="" visible={isModalVisible} onCancel={() => setIsModalVisible(false)}>
                <div className="table-wrapper">
                    <Table size="middle" bordered columns={columns} dataSource={fileData} pagination={false} />
                </div>
            </Modal>
        </div>
    )
}